import { FC } from 'react';
import { Link } from 'react-router-dom';
import { CircleHelp } from 'lucide-react';
import HeaderProfileMenu from './HeaderProfileMenu';
import { usePageTitle } from './usePageTitle';
import { usePageTabsContext } from '../LayoutWrapper/PageTabsContext';
import { MaskedStudentData } from '../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../analytics/dataMasking';

const KNOWLEDGE_BASE_URL = 'https://newclassrooms-12mm.help.userguiding.com/en';

const TopHeader: FC = () => {
  const { parent, title, icon: PageIcon, piiUserId } = usePageTitle();
  const { tabs, activeTab, setActiveTab } = usePageTabsContext();

  return (
    <header className="nc_top-header-wrap" role="banner" data-testid="topHeader">
      <div className="nc_top-header">
        <h1 className="nc_top-header__title">
          {PageIcon && <PageIcon size={26} aria-hidden="true" />}
          {parent && (
            <>
              <Link
                to={parent.to}
                id="breadCrumbClasses"
                className="nc_top-header__parent"
                data-testid="topHeaderParent"
              >
                {parent.label}
              </Link>
              <span className="nc_top-header__separator" aria-hidden="true">
                /
              </span>
            </>
          )}
          {piiUserId ? (
            <MaskedStudentData student={{ publicUserId: piiUserId }} type={PiiTypes.FullName}>
              {title}
            </MaskedStudentData>
          ) : (
            <span>{title}</span>
          )}
        </h1>

        <div className="nc_top-header__actions">
          <button
            type="button"
            className="nc_top-header__help"
            aria-label="Open the knowledge base"
            onClick={() => window.open(KNOWLEDGE_BASE_URL, '_blank', 'noopener,noreferrer')}
          >
            <CircleHelp size={24} aria-hidden="true" />
          </button>
          <HeaderProfileMenu />
        </div>
      </div>

      {tabs.length > 0 && (
        <div className="nc_top-header__tabs" role="tablist">
          {tabs.map((tab, index) => (
            <button
              key={tab.label}
              type="button"
              role="tab"
              id={tab.id}
              aria-selected={index === activeTab}
              className={`nc_top-header__tab ${index === activeTab ? 'nc_top-header__tab--active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default TopHeader;
